import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { commaDeliminate } from '../../utilities/stringUtilities'
import { Field } from 'react-final-form'
import styles from './index.module.scss'
import cn from 'classnames'
import FormGroupAdapter from '../form-group-adaptor'
export default function TicketFee ({
  form,
  onDestroy,
  ticketFee,
  value,
  index,
  formatValue,
  updateDiscountAndTax,
  ticketFeeTotal,
  isRecurring = false
}) {
  const [showDescription, setshowDescription] = useState(false)

  const updateTicketFeeTotalFromQuantity = (val) => {
    const formattedValue = formatValue(val)

    form.change(`${ticketFee}.quantity`, formattedValue)

    if (value?.amount) {
      form.change(`${ticketFee}.total`, formattedValue * value.amount)
    }
    if (!isRecurring && updateDiscountAndTax) {
      updateDiscountAndTax(form, ticketFeeTotal)
    }
  }

  const updateTicketFeeTotalFromAmount = (val) => {
    form.change(`${ticketFee}.amount`, val)

    if (value?.quantity) {
      form.change(`${ticketFee}.total`, val * value.quantity)
    }
    if (!isRecurring && updateDiscountAndTax) {
      updateDiscountAndTax(form, ticketFeeTotal)
    }
  }

  const truncateDescription = (description) => {
    if (!description) return ''
    if (description.length > 100) {
      return description.substring(0, 100) + '...'
    }
    return description
  }

  return (
    <div className={styles.ticketFeeItem}>
      <div className={styles.ticketFeeFormSection}>
        <div className={styles.feeTypeBtnDescription}>
          <button
            type='button'
            className={styles.removeFeeButton}
            onClick={() => onDestroy(form, index, ticketFeeTotal)}>
            <i className={`material-icons ${styles.removeFeeIcon}`}>
              close
            </i>
          </button>
          <span className={styles.feeTypeName}>{value.feeType.name}</span>
        </div>

        <div className={styles.ticketFeeQtyPrice}>
          <label className={`control-label ${styles.feesInput}`} htmlFor={`${ticketFee}.quantity`}>
            Quantity
            <Field
              name={`${ticketFee}.quantity`}
              min={0}
              max={999999.999}
              step='.001'
              type='number'
              component={FormGroupAdapter}
              inputOnChange={(e) => updateTicketFeeTotalFromQuantity(e.currentTarget.value)}
            />
          </label>
          <label className={`control-label ${styles.feesInput}`} htmlFor={`${ticketFee}.amount`}>
            Price
            <Field
              name={`${ticketFee}.amount`}
              min={0}
              max={999999.99}
              step='0.01'
              type='number'
              component={FormGroupAdapter}
              inputOnChange={(e) => updateTicketFeeTotalFromAmount(e.currentTarget.value)}
            />
          </label>
          <span className={styles.feeTotal}>
            ${commaDeliminate(value?.total)}
          </span>
        </div>
      </div>

      <div className={cn({
        [styles.ticketFeeDescription]: !showDescription,
        [styles.editingDescription]: showDescription
      })}>
        {value.description?.length > 0 && !showDescription && <div className={styles.ticketFeDescriptionContainer}>
          <span>{truncateDescription(value.description)}</span>
          <button type='button' className={styles.editDescriptionButton} onClick={() => setshowDescription(!showDescription)}>
            Edit
          </button>
        </div>}
        {!value.description && !showDescription && (
          <button type='button' className={styles.displayFormButton} onClick={() => setshowDescription(!showDescription)}>
            + Description
          </button>
        )}
        {showDescription &&
          <>
            <button type='button' className={styles.displayFormButton} onClick={() => setshowDescription(!showDescription)}>
              - Description
            </button>
            <div className={styles.descriptionContainer}>
              <Field name={`${ticketFee}.description`}>
                {({ input }) => (
                  <>
                    <label className='control-label hidden' htmlFor='description'>Description</label>
                    <textarea
                      {...input}
                      type='text'
                      className='form-control'
                      maxLength='4000'
                    />
                  </>
                )}
              </Field>
              <button
                type='button'
                className={styles.clearDescription}
                onClick={() => form.mutators.clearDescription(ticketFee)}>
                Clear
              </button>
            </div>
          </>
        }
      </div>
    </div>
  )
}

TicketFee.propTypes = {
  form: PropTypes.object,
  index: PropTypes.number,
  onDestroy: PropTypes.func.isRequired,
  ticketFee: PropTypes.string,
  value: PropTypes.object,
  formatValue: PropTypes.func.isRequired,
  updateDiscountAndTax: PropTypes.func,
  ticketFeeTotal: PropTypes.number,
  isRecurring: PropTypes.bool
}
